<template>
  <!-- 上传文件 -->
  <el-dialog
    :title="`文件上传`"
    :visible.sync="visible"
    class="file-upload"
    append-to-body
    center>
      <div style="text-align: center;">
        <el-upload
        class="upload-demo"
        drag
        action="#"
        :auto-upload="false"
        ref="fileUpload"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处 <em>上传</em></div>
      </el-upload>
      <div class="mt10"><span class="span_required">*</span>文件名 <el-input class="input200" v-model="name"></el-input></div>
      <div class="mt10" v-if="fileTypes.length > 0"><span class="span_required">*</span>类型 
        <el-select class="input200 ml5" v-model="type" :placeholder="`请选择`">
          <el-option
            v-for="item in fileTypes"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="upload()">确定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'FileUpload',
  data() {
    return {
      visible: false,
      name: '',
      type: '',
      fileTypes: []
    }
  },
  methods: {
    async upload() {
      const { name } = this
      if (!name) {
        // 名称为必填
        this.$message.error(`名称不能为空`)   
        return     
      }
      if (this.fileTypes.length > 0 && !this.type) {
        // this.$message.error('类型为必选')   
        this.$message.error(`类型不能为空`)   
        return 
      }
      const file = this.$refs.fileUpload.uploadFiles[0]
      if (!file) {
        // this.$message.error('请选择文件')
        this.$message.error(`请选择文件`)   
        return
      }
      const item = {
        raw: file.raw,
        filename: file.name,
        size: file.size,
        name: name,
        type: this.type
      }
      const res = await this.$upload.start(item)
      if (res) {
        const item = Object.assign({ name, type: this.type }, res)
        this.complete(item)
      }
    },
    complete(file) {
      this.$emit('complete', file)
      this.reset()
      this.visible = false
    },
    reset() {
      this.$refs.fileUpload.uploadFiles = []
      this.name = ''
      this.fileTypes = []
      this.type = ''
    },
    show(fileTypes = []) {
      this.fileTypes = fileTypes
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .file-upload {
    /deep/ .el-dialog {
      width: 450px;
    }
    .span_required{
      color:red;
      font-size:18px;
    }
  }
</style>